@if (!slideEditMode) {
    <div fxLayout="row" fxLayoutAlign="center" class="side-main-menu">
        @if (!minimized) {
            <span class="drawerHeader" style="padding-top: 4px;">{{ 'general.toolbox' | transloco }}</span>
            <mat-icon (click)="onMinimized()" style="position: absolute; right: 10px; top: 4px; cursor: pointer">keyboard_double_arrow_left</mat-icon>
        }
        @if (minimized) {
            <mat-icon (click)="onMaximized()" style="position: absolute; right: 10px; top: 4px; cursor: pointer">keyboard_double_arrow_right</mat-icon>
        }
    </div>
}

<mat-drawer-container class="drawer-container" autosize>
    <mat-drawer mode="side" opened style="width: 72px" [position]="slideEditMode ? 'end': 'start'">
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'layers'}" (click)="setActiveTemplate('layers')">
                <fa-icon size="2xl" [icon]="faLayerGroup"></fa-icon>
                {{ 'general.layers' | transloco }}
            </div>
        }
        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'components'}" (click)="setActiveTemplate('components')">
            <fa-icon size="2xl" [icon]="faPuzzlePiece"></fa-icon>
            {{ 'general.components' | transloco }}
        </div>
        @if (isMimeMainPlayer && experienceLevel > experienceLevelType.BEGINNER) {
            <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'scenes'}" (click)="setActiveTemplate('scenes')">
                <fa-icon size="2xl" [icon]="faLocationCrosshairs"></fa-icon>
                {{ 'general.scenes' | transloco }}
            </div>
        }
        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'resources'}" (click)="setActiveTemplate('resources')">
            <fa-icon size="2xl" [icon]="faPhotoFilm"></fa-icon>
            {{ 'general.resources' | transloco }}
        </div>
        @if (scheduledEnabled === '1' && experienceLevel > experienceLevelType.BEGINNER) {
            <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'schedulers'}" (click)="setActiveTemplate('schedulers')">
                <fa-icon size="2xl" [icon]="faCalendarCheck"></fa-icon>
                {{ 'navigation.schedulers' | transloco }}
            </div>
        }
        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'stickers'}" (click)="setActiveTemplate('stickers')">
            <fa-icon size="2xl" [icon]="faAsterisk"></fa-icon>
            {{ 'general.stickers' | transloco }}
        </div>
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'animation'}" (click)="setActiveTemplate('animation')">
                <fa-icon size="2xl" [icon]="faArrowUpRightDots"></fa-icon>
                {{ 'general.motion' | transloco }}
            </div>
        }
        <div class="menu-button" [ngClass]="{'active': this.activeTemplate === 'backgrounds'}" (click)="setActiveTemplate('backgrounds')">
            <fa-icon size="2xl" [icon]="faImage"></fa-icon>
            {{ 'general.backgrounds' | transloco }}
        </div>
    </mat-drawer>

    <mat-drawer-content>
        <div [style.width.px]="minimized ? 0 : 265">
            <ng-container *ngTemplateOutlet="getTemplate(activeTemplate)"></ng-container>
            <ng-template #layersTemplate>
                <app-scene-layers></app-scene-layers>
            </ng-template>
            <ng-template #componentsTemplate matExpansionPanelContent>
                <app-scene-add-blocks [addBlockType]="'BLOCK_COMPONENTS'"></app-scene-add-blocks>
            </ng-template>
            <ng-template #scenesTemplate matExpansionPanelContent>
                <app-scene-add-content [addBlockType]="'BLOCK_SCENES'"></app-scene-add-content>
            </ng-template>
            <ng-template #resourcesTemplate matExpansionPanelContent>
                <app-scene-add-content [addBlockType]="'BLOCK_RESOURCES'"></app-scene-add-content>
            </ng-template>
            <ng-template #schedulersTemplate matExpansionPanelContent>
                <app-scene-add-blocks [addBlockType]="'BLOCK_SCHEDULER'"></app-scene-add-blocks>
            </ng-template>
            <ng-template #stickersTemplate matExpansionPanelContent>
                <app-scene-add-sticker></app-scene-add-sticker>
            </ng-template>
            <ng-template #animationTemplate matExpansionPanelContent>
                <app-scene-add-animation></app-scene-add-animation>
            </ng-template>
            <ng-template #backgroundsTemplate matExpansionPanelContent>
                <app-backgrounds-texts></app-backgrounds-texts>
            </ng-template>
        </div>
    </mat-drawer-content>
</mat-drawer-container>

